export default "__VITE_ASSET__f5b2e5ab__"